import React from 'react';
import { Checkbox } from '../../comps/checkbox';
import { ls } from '../../locale';
import { numberFormatter, stringFormatter } from '../../helpers';
import { SectionTitle } from '../../comps/section-title';

type HoldBookingProps = {
  holding: boolean;
  price: number;
  currencyCode: string;
  disabled: boolean;
  onChange: (checked: boolean) => void;
};  

export const HoldBooking = ({holding, price, currencyCode, disabled, onChange}: HoldBookingProps) => {

  const handleChange = (checked: boolean) => {
    onChange(checked);
  };

  const rHoldBooking = ls.t('CheckoutPage.HoldBooking')
  const detail = stringFormatter.formatString(rHoldBooking.Detail, `${currencyCode} ${numberFormatter.formatCurrency(price)}`)
  
  return (
    <div className="tw-mb-12 tw-mt-8">
      <SectionTitle title={rHoldBooking.Title} />
      <div className="tw-flex tw-flex-row tw-gap-2">
        <div className="tw-flex tw-items-center tw-justify-center">
          <img src="/images/hold-booking.png" alt="Hold Booking" className="tw-w-12 tw-h-12 tw-object-cover"/>
        </div>
        <div className="tw-flex tw-flex-col tw-justify-between">
          <div>{rHoldBooking.Desc}</div>
          <Checkbox checked={holding} onChange={handleChange} disabled={disabled}>{detail}</Checkbox>
        </div>
      </div>
    </div>
  );
}

